module.exports = "::ng-deep .custom-tooltip {\n\tfont-size: 14px;\n\tbackground: #6ee229;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-enroll/change-phone-number/change-phone-number.component.css
// module id = ./src/app/customer-enroll/change-phone-number/change-phone-number.component.css
// module chunks = main